'use strict';
angular.module('clientDashboardApp').directive('updateOverlay',function(){
  return {
    restrict: "E",
    template: `<div class="update-overlay">
    <div>
        <div class="spinner-wrapper">
            <span class="fas fa-spinner fa-spin fa-2x"></span>
        </div>
        <h4 >Updating {{overlayConfig.message}}</h4>
    </div>`,
    scope: {
      state: "=",
      overlayConfig: "="
    }
  }

});
